import { api } from './client';
import type { Estimate, EstimateListItem, EstimateLine, Paginated } from '@/types';

export const estimatesApi = {
  async list(filters: { contract?: number; kind?: string; status?: string; search?: string } = {}): Promise<Paginated<EstimateListItem>> {
    const { data } = await api.get<Paginated<EstimateListItem>>('/estimates/', { params: filters });
    return data;
  },
  async get(id: number): Promise<Estimate> {
    const { data } = await api.get<Estimate>(`/estimates/${id}/`);
    return data;
  },
  async create(payload: Partial<Estimate>): Promise<Estimate> {
    const { data } = await api.post<Estimate>('/estimates/', payload);
    return data;
  },
  async lines(id: number): Promise<EstimateLine[]> {
    const { data } = await api.get<EstimateLine[]>(`/estimates/${id}/lines/`);
    return data;
  },
  async approve(id: number): Promise<Estimate> {
    const { data } = await api.post<Estimate>(`/estimates/${id}/approve/`);
    return data;
  },
  async reject(id: number): Promise<Estimate> {
    const { data } = await api.post<Estimate>(`/estimates/${id}/reject/`);
    return data;
  },
  async aiCheck(id: number): Promise<{ result?: string; provider?: string; task_id?: string }> {
    const { data } = await api.post(`/estimates/${id}/ai-check/`);
    return data;
  },
  async importExcel(file: File, contractId: number, number: string, kind = 'local'): Promise<{ imported: number; total: string; warnings: string[] }> {
    const form = new FormData();
    form.append('file', file);
    form.append('contract', String(contractId));
    form.append('number', number);
    form.append('kind', kind);
    const { data } = await api.post('/estimates/import-excel/', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  },
  exportExcelUrl(id: number): string {
    return `${import.meta.env.VITE_API_BASE_URL || '/api/v1'}/estimates/${id}/export-excel/`;
  },
};
